import React, { useState, useReducer } from "react";
import "./market-sizing.css";
import NavBar from "../../../../layout/navbar/navbar";
import BasicVersion from "./versions/basic-version";
import {
  Accordion,
  Col,
  Card,
  Container,
  Tabs,
  Tab,
  Row,
} from "react-bootstrap";
import { FaChevronLeft, FaChevronDown, FaEllipsisH } from "react-icons/fa";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { useSupabaseApp } from "../../../../SupabaseApp.js";

/**
 * MarketSizing Component
 * 
 * Market sizing calculator helping founders estimate Total Addressable Market (TAM),
 * Serviceable Addressable Market (SAM), and Serviceable Obtainable Market (SOM).
 * Uses useReducer to manage method selection (pre-revenue vs other approaches).
 * Displays tabbed interface with BasicVersion component for pre-revenue method.
 * Features accordion-based method selection with expand/collapse UI.
 * Determines market potential for fundraising and business planning.
 * Requires user authentication.
 * 
 * @returns {JSX.Element} Page with market sizing calculator and methods
 */
const MarketSizing = (props) => {
  // Get Supabase utilities and verify user authentication
  const { supabase, currentUser } = useSupabaseApp();

  // Check if user is logged in
  if (!currentUser) {
    throw new Error(`Must be logged in`);
  }

  /**
   * Reducer function to manage market sizing method selection state
   * Handles method toggles for different valuation/sizing approaches
   * 
   * @param {Object} state - Current reducer state (preRevenueMethod boolean)
   * @param {Object} action - Action object with type field
   * @returns {Object} Updated state after action applied
   */
  const [state, dispatch] = useReducer(reducer, {
    preRevenueMethod: true,
  });

  // Method reducer dispatcher - updates state based on action type
  function reducer(state, action) {
    let newState;

    switch (action.type) {
      case "change preRevenueMethod":
        newState = {
          preRevenueMethod: !state.preRevenueMethod,
        };
        break;

      default:
        throw new Error();
    }

    return newState;
  }

  return (
    <>
      {/* navbar */}
      <NavBar />

      {/* market sizing */}
      <div id="marketsizing">
        <Container className="col-11" style={{ paddingBottom: "200px" }}>
          {/* title and info note */}
          <div id="title-div">
            <span id="title-text">
              Market sizing
              <sup data-tip="">
                <IoMdInformationCircleOutline id="information-icon" />
              </sup>
            </span>
          </div>

          {/* tabs based on methods */}
          <div>
            <Tabs className="companytabs" defaultActiveKey="basicVersion">
              <Tab
                eventKey="basicVersion"
                title="Basic"
                style={{ marginTop: "0" }}
              >
                <div className="tab-body">
                  <Accordion defaultActiveKey="preRevenueMethod">
                    <Accordion.Item eventKey="preRevenueMethod">
                      <Accordion.Header
                        className="companycardheader"
                        onClick={() =>
                          dispatch({ type: "change preRevenueMethod" })
                        }
                      >
                        <div className="companyarrowicon">
                          {state.basicvcmethod ? (
                            <FaChevronDown className="arrow-icon" />
                          ) : (
                            <FaChevronLeft className="arrow-icon" />
                          )}
                        </div>

                        <div className="companytitlecard">
                          Pre-revenue method
                        </div>

                        <div className="companyellipsisicon">
                          <FaEllipsisH />
                        </div>
                      </Accordion.Header>

                      <Accordion.Body style={{ fontFamily: "AileronRegular" }}>
                        <BasicVersion supabase={supabase} />
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Tab>
            </Tabs>
          </div>
        </Container>
      </div>
    </>
  );
};

export default MarketSizing;
